<template>
  <div>
    <a-list
      itemLayout="horizontal"
      :dataSource="vehicleGroups"
      :locale="locale"
    >
      <a-list-item>
        <template #renderItem="{ item }">
          <a-list-item-meta>
            <template #description>
              <a-row :gutter="16">
                <a-col :span="1">
                  <a-icon
                    type="close"
                    @click="clickDelete(item.VehicleGroupID)"
                  />
                </a-col>
                <a-col :span="10">
                  <span :style="{ color: 'black' }">
                    {{ $t('js.chung_loai_xe') }}
                    <b>{{ item.VehicleGroupName }}</b> {{ $t('js.so_luong_2cdc5885') }}
                    <b>{{ item.RouteNumber }}</b>
                  </span>
                </a-col>
              </a-row>
            </template>
          </a-list-item-meta>
        </template>
      </a-list-item>
    </a-list>
    <a-button @click="clickAdd">
      <!-- <a-icon type="plus" />Thêm yêu cầu xe -->
    </a-button>
    <a-modal
      :title="$t('js.yeu_cau_chung_loai_xe')"
      centered
      v-model="vehicleGroupModalVisible"
      :okText="$t('js.them_cc88682f')"
      :cancelText="$t('js.huy_34ca764c')"
      @cancel="clickCancel"
      @ok="clickSave"
    >
      <a-form layout="vertical">
        <a-row :gutter="16">
          <a-col :span="8">
            <!-- <span>{{ $t('js.chung_loai_xe') }}</span> -->
          </a-col>
          <a-col :span="16">
            <a-select
              :value="vehicleGroup.VehicleGroupID"
              :placeholder="$t('js.vui_long_chon_chung_loai_xe')"
              @change="change"
            >
              <a-select-option
                v-for="item in vehicleGroupCategories"
                :key="item.id"
                >{{ item.text }}</a-select-option
              >
            </a-select>
          </a-col>
        </a-row>
        <a-row :gutter="16" :style="{ marginTop: '16px' }">
          <a-col :span="8">
            <!-- <span>{{ $t('js.so_luong') }}</span> -->
          </a-col>
          <a-col :span="16">
            <a-input-number
              v-model="vehicleGroup.RouteNumber"
              :min="1"
              :max="999999"
            />
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import axios from "axios";

const vehicleGroupCategories = [];
export default {
  data: () => ({
    vehicleGroupCategories,
    locationModalVisible: false,
    vehicleGroupModalVisible: false,
    vehicleGroup: {
      VehicleGroupID: null,
      VehicleGroupName: null,
      RouteNumber: 1,
    },
    locale: {
      emptyText: window.__t('js.khong_co_du_lieu'),
    },
  }),
  props: {
    vehicleGroups: {
      type: Array, // not 'number'
      required: false,
      default: [],
    },
  },
  beforeCreate() {},
  mounted() {
    axios
      .get("c-vehicle-group/items")
      .then((response) => {
        this.vehicleGroupCategories = response.data.results;
      })
      .catch((error) => {
        console.log(error.toString());
      });
  },
  methods: {
    clickAdd(e) {
      this.vehicleGroup.RouteNumber = 1;
      this.vehicleGroup.VehicleGroupID = this.vehicleGroupCategories[0].id;
      this.vehicleGroup.VehicleGroupName = this.vehicleGroupCategories[0].text;
      this.vehicleGroupModalVisible = true;
    },
    clickCancel(e) {
      this.vehicleGroup.RouteNumber = 1;
      this.vehicleGroup.VehicleGroupID = 0;
      this.vehicleGroup.VehicleGroupName = null;
      this.vehicleGroupModalVisible = false;
    },
    clickSave(e) {
      this.vehicleGroups = this.vehicleGroups.filter(
        (p) => p.VehicleGroupID != this.vehicleGroup.VehicleGroupID
      );
      const vehicleGroup = Object.assign({}, this.vehicleGroup);
      this.vehicleGroups.push(vehicleGroup);
      this.vehicleGroupModalVisible = false;
      this.$emit("emit-vehicle-groups", this.vehicleGroups);
    },
    clickDelete(vehicleGroupID) {
      this.vehicleGroups = this.vehicleGroups.filter(
        (p) => p.VehicleGroupID != vehicleGroupID
      );
      this.$emit("emit-vehicle-groups", this.vehicleGroups);
    },
    change(value) {
      this.vehicleGroup.VehicleGroupID = value;
      this.vehicleGroup.VehicleGroupName = this.vehicleGroupCategories.find(
        (p) => p.id == value
      ).text;
    },
  },
};
</script>
<style scoped>
</style>